import { createContext, useContext, useState } from 'react';

const AuthModalContext = createContext(undefined);

export const AuthModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('unauthenticated');

  const openModal = (modalType) => {
    setType(modalType);
    setOpen(true);
  };
  const closeModal = () => setOpen(false);

  return (
    <AuthModalContext.Provider value={{ open, type, openModal, closeModal }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => {
  const ctx = useContext(AuthModalContext);
  if (!ctx) {
    throw new Error('useAuthModal must be used within an AuthModalProvider');
  }
  return ctx;
};
